import type { CatalogProduct, CatalogCategory } from './types'

// =============================================================================
// Categories
// =============================================================================

export const categories: CatalogCategory[] = [
  { id: 'vlekverwijdering', name: 'Vlekverwijdering', slug: 'vlekverwijdering', order: 1 },
  { id: 'schoonmaakmiddelen', name: 'Schoonmaakmiddelen', slug: 'schoonmaakmiddelen', order: 2 },
  { id: 'stofzuigers', name: 'Stofzuigers', slug: 'stofzuigers', order: 3 },
  { id: 'ondertapijten', name: 'Ondertapijten', slug: 'ondertapijten', order: 4 },
  { id: 'inloopmatten', name: 'Inloopmatten', slug: 'inloopmatten', order: 5 },
  { id: 'bescherming', name: 'Bescherming', slug: 'bescherming', order: 6 },
  { id: 'sebo-onderdelen', name: 'SEBO Onderdelen', slug: 'sebo-onderdelen', order: 7 },
  { id: 'apparaten-verhuur', name: 'Apparaten Huren', slug: 'apparaten-verhuur', order: 8 },
]

// =============================================================================
// Products — generated from brands/schoonhuisshop/.../products/*.yaml
// =============================================================================

export const products: CatalogProduct[] = [
  // ---------------------------------------------------------------------------
  // Vlekverwijdering
  // ---------------------------------------------------------------------------
  {
    id: 'vlekkenbaas-400ml',
    name: 'Vlekkenbaas 400ml',
    slug: 'vlekkenbaas-400ml',
    brand: 'Cinco Cleaning',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 1750,
    weight: 550,
    sfProductCode: 'SHS-VLEK-VLEKKENBAAS-400',
    dropship: false,
    stock: true,
    image: '/products/vlekkenbaas-400ml.png',
  },
  {
    id: 'vlekkenbaas-2-pack',
    name: 'Vlekkenbaas 2-pack (2× 400ml)',
    slug: 'vlekkenbaas-2-pack',
    brand: 'Cinco Cleaning',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 2995,
    weight: 1100,
    sfProductCode: 'SHS-VLEK-VLEKKENBAAS-2PK',
    dropship: false,
    stock: true,
    image: '/products/vlekkenbaas-1l.png',
  },
  {
    id: 'james-vlekkenwonder',
    name: 'James Vlekkenwonder',
    slug: 'james-vlekkenwonder',
    brand: 'James',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 1495,
    weight: 287,
    sfProductCode: 'SHS-VLEK-JAMES-WONDER',
    dropship: false,
    stock: true,
    image: '/products/james-vlekkenwonder.png',
  },
  {
    id: 'james-vlekkenschijf',
    name: 'James Vlekkenschijf',
    slug: 'james-vlekkenschijf',
    brand: 'James',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 95,
    weight: 30,
    sfProductCode: 'SHS-VLEK-JAMES-SCHIJF',
    dropship: false,
    stock: true,
    image: '/products/james-vlekkenschijf.png',
  },
  {
    id: 'vlekkendoekjes-katoen',
    name: 'Set 3 witte vlekkendoekjes katoen',
    slug: 'vlekkendoekjes-katoen',
    brand: 'Cinco Cleaning',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 795,
    weight: 100,
    sfProductCode: 'SHS-VLEK-DOEKJES-KATOEN',
    dropship: false,
    stock: true,
    image: '/products/vlekkendoekjes-katoen.png',
  },
  {
    id: 'james-starterset-tapijt',
    name: 'James Starterset Tapijt en Meubelstof',
    slug: 'james-starterset-tapijt',
    brand: 'James',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 2995,
    weight: 500,
    sfProductCode: 'SHS-VLEK-JAMES-SET-TAPIJT',
    dropship: false,
    stock: true,
    image: '/products/james-starterset-tapijt.png',
  },
  // UF2000 (Ecodor) — also in vlekverwijdering category
  {
    id: 'uf2000-ecodor-500ml',
    name: 'UF2000 Urinegeur Verwijderaar 500ml',
    slug: 'uf2000-ecodor-500ml',
    brand: 'Ecodor',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 1695,
    weight: 700,
    sfProductCode: 'SHS-VLEK-UF2000-500',
    dropship: false,
    stock: true,
    image: '/products/uf2000-ecodor-500ml.png',
  },
  {
    id: 'uf2000-ecodor-1l',
    name: 'UF2000 Urinegeur Verwijderaar 1 Liter Navul',
    slug: 'uf2000-ecodor-1l',
    brand: 'Ecodor',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 2295,
    weight: 1065,
    sfProductCode: 'SHS-VLEK-UF2000-1L',
    dropship: false,
    stock: true,
    image: '/products/uf2000-ecodor-1l.png',
  },
  {
    id: 'uf2000-ecodor-duopack',
    name: 'UF2000 Duopack (2× 500ml)',
    slug: 'uf2000-ecodor-duopack',
    brand: 'Ecodor',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 2895,
    weight: 1400,
    sfProductCode: 'SHS-VLEK-UF2000-DUO',
    dropship: false,
    stock: true,
    image: '/products/uf2000-duopack.png',
  },
  {
    id: 'uf2000-ecodor-navulset',
    name: 'UF2000 Navulset (500ml + 1L navul)',
    slug: 'uf2000-ecodor-navulset',
    brand: 'Ecodor',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 3495,
    weight: 1700,
    sfProductCode: 'SHS-VLEK-UF2000-NAVULSET',
    dropship: false,
    stock: true,
    image: '/products/uf2000-navulset.png',
  },
  {
    id: 'uf2000-ecodor-ecolight',
    name: 'UF2000 500ml + EcoLight UV Urinevlek Detector',
    slug: 'uf2000-ecodor-ecolight',
    brand: 'Ecodor',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 2495,
    weight: 900,
    sfProductCode: 'SHS-VLEK-UF2000-ECOLIGHT',
    dropship: false,
    stock: true,
    image: '/products/uf2000-ecolight.png',
  },
  {
    id: 'uf2000-ecodor-6pack',
    name: 'UF2000 Voordeelpack (6× 500ml)',
    slug: 'uf2000-ecodor-6pack',
    brand: 'Ecodor',
    category: 'vlekverwijdering',
    type: 'simple',
    price: 7995,
    weight: 3500,
    sfProductCode: 'SHS-VLEK-UF2000-6PK',
    dropship: false,
    stock: true,
    image: '/products/uf2000-6pack.png',
  },

  // ---------------------------------------------------------------------------
  // Schoonmaakmiddelen
  // ---------------------------------------------------------------------------
  {
    id: 'james-basisreiniger',
    name: 'James Basisreiniger',
    slug: 'james-basisreiniger',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 1595,
    weight: 1100,
    sfProductCode: 'SHS-REIN-JAMES-BASIS',
    dropship: false,
    stock: true,
    image: '/products/james-basisreiniger.png',
  },
  {
    id: 'james-vloerreiniger-a',
    name: 'James Vloerreiniger Schoon & Snel Droog (A)',
    slug: 'james-vloerreiniger-a',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 1495,
    weight: 1100,
    sfProductCode: 'SHS-REIN-JAMES-VLOER-A',
    dropship: false,
    stock: true,
    image: '/products/james-vloerreiniger-a.png',
  },
  {
    id: 'james-vloerreiniger-b',
    name: 'James Vloerreiniger Beschermt & Herstelt (B)',
    slug: 'james-vloerreiniger-b',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 1595,
    weight: 1100,
    sfProductCode: 'SHS-REIN-JAMES-VLOER-B',
    dropship: false,
    stock: true,
    image: '/products/james-vloerreiniger-b.png',
  },
  {
    id: 'james-zijdemat',
    name: 'James Zijdemat',
    slug: 'james-zijdemat',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 1995,
    weight: 1100,
    sfProductCode: 'SHS-REIN-JAMES-ZIJDEMAT',
    dropship: false,
    stock: true,
    image: '/products/james-zijdemat.png',
  },
  {
    id: 'james-remover',
    name: 'James Remover',
    slug: 'james-remover',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 1595,
    weight: 300,
    sfProductCode: 'SHS-REIN-JAMES-REMOVER',
    dropship: false,
    stock: true,
    image: '/products/james-remover.png',
  },
  {
    id: 'james-interieurreiniger',
    name: 'James Interieurreiniger',
    slug: 'james-interieurreiniger',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 1795,
    weight: 550,
    sfProductCode: 'SHS-REIN-JAMES-INTERIEUR',
    dropship: false,
    stock: true,
    image: '/products/james-interieurreiniger.png',
  },
  {
    id: 'james-cleansoft',
    name: 'James Cleansoft',
    slug: 'james-cleansoft',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 1595,
    weight: 560,
    sfProductCode: 'SHS-REIN-JAMES-CLEANSOFT',
    dropship: false,
    stock: true,
    image: '/products/james-cleansoft.png',
  },
  {
    id: 'james-cleanmaster',
    name: 'James Cleanmaster',
    slug: 'james-cleanmaster',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 1595,
    weight: 560,
    sfProductCode: 'SHS-REIN-JAMES-CLEANMASTER',
    dropship: false,
    stock: true,
    image: '/products/james-cleanmaster.png',
  },
  {
    id: 'james-starterset-harde-vloeren',
    name: 'James Starterset Harde Vloeren',
    slug: 'james-starterset-harde-vloeren',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 2995,
    weight: 500,
    sfProductCode: 'SHS-REIN-JAMES-SET-HARDE',
    dropship: false,
    stock: true,
    image: '/products/james-starterset-harde-vloeren.png',
  },
  {
    id: 'james-set-harde-vloeren',
    name: 'James Set Harde Vloeren',
    slug: 'james-set-harde-vloeren',
    brand: 'James',
    category: 'schoonmaakmiddelen',
    type: 'simple',
    price: 3995,
    weight: 2500,
    sfProductCode: 'SHS-REIN-JAMES-SET-VLOER',
    dropship: false,
    stock: true,
    image: '/products/james-set-harde-vloeren.png',
  },

  // ---------------------------------------------------------------------------
  // Stofzuigers (dropship — SEBO)
  // ---------------------------------------------------------------------------
  {
    id: 'sebo-d4-premium',
    name: 'SEBO D4 Premium',
    slug: 'sebo-d4-premium',
    brand: 'SEBO',
    category: 'stofzuigers',
    type: 'simple',
    price: 59900,
    weight: 7000,
    sfProductCode: 'SHS-STOF-SEBO-D4',
    dropship: true,
    stock: true,
    image: '/products/sebo-d4-premium.png',
  },
  {
    id: 'sebo-d3-parket',
    name: 'SEBO D3 Parket',
    slug: 'sebo-d3-parket',
    brand: 'SEBO',
    category: 'stofzuigers',
    type: 'simple',
    price: 34900,
    weight: 6900,
    sfProductCode: 'SHS-STOF-SEBO-D3',
    dropship: true,
    stock: true,
    image: '/products/sebo-d3-parket.png',
  },
  {
    id: 'sebo-felix-1',
    name: 'SEBO Felix 1 Premium',
    slug: 'sebo-felix-1',
    brand: 'SEBO',
    category: 'stofzuigers',
    type: 'simple',
    price: 45900,
    weight: 6200,
    sfProductCode: 'SHS-STOF-SEBO-FELIX1',
    dropship: true,
    stock: true,
    image: '/products/sebo-felix-1.png',
  },
  {
    id: 'sebo-automatic-x7',
    name: 'SEBO Automatic X7',
    slug: 'sebo-automatic-x7',
    brand: 'SEBO',
    category: 'stofzuigers',
    type: 'simple',
    price: 44900,
    weight: 8000,
    sfProductCode: 'SHS-STOF-SEBO-X7',
    dropship: true,
    stock: true,
    image: '/products/sebo-automatic-x7.png',
  },
  {
    id: 'sebo-zakken-d-serie',
    name: 'SEBO Stofzuigerzakken D-serie (8 stuks)',
    slug: 'sebo-zakken-d-serie',
    brand: 'SEBO',
    category: 'stofzuigers',
    type: 'simple',
    price: 1799,
    weight: 200,
    sfProductCode: 'SHS-STOF-SEBO-ZAK-D',
    dropship: true,
    stock: true,
    image: '/products/sebo-zakken-d.png',
  },
  {
    id: 'sebo-zakken-x-serie',
    name: 'SEBO Stofzuigerzakken X-serie (8 stuks)',
    slug: 'sebo-zakken-x-serie',
    brand: 'SEBO',
    category: 'stofzuigers',
    type: 'simple',
    price: 1499,
    weight: 200,
    sfProductCode: 'SHS-STOF-SEBO-ZAK-X',
    dropship: true,
    stock: true,
    image: '/products/sebo-zakken-x.png',
  },
  {
    id: 'sebo-zakken-felix',
    name: 'SEBO Stofzuigerzakken Felix (8 stuks)',
    slug: 'sebo-zakken-felix',
    brand: 'SEBO',
    category: 'stofzuigers',
    type: 'simple',
    price: 1799,
    weight: 200,
    sfProductCode: 'SHS-STOF-SEBO-ZAK-FELIX',
    dropship: true,
    stock: true,
    image: '/products/sebo-zakken-felix.png',
  },

  // ---------------------------------------------------------------------------
  // Ondertapijten (custom-size)
  // ---------------------------------------------------------------------------
  {
    id: 'kleda-base',
    name: 'Kleda Base Ondertapijt',
    slug: 'kleda-base',
    brand: 'Kleda',
    category: 'ondertapijten',
    type: 'custom-size',
    price: null,
    customPricing: { unit: 'm2', pricePerUnit: 2250, minWidth: 60, maxWidth: 240, minLength: 50, maxLength: 3000, widthStep: 10, lengthStep: 1 },
    weight: 1200,
    sfProductCode: 'SHS-ONDER-KLEDA-BASE',
    dropship: false,
    stock: true,
    image: '/products/kleda-base.jpg',
  },

  // ---------------------------------------------------------------------------
  // Inloopmatten (custom-size)
  // ---------------------------------------------------------------------------
  {
    id: 'cinco-schoonloopmat',
    name: 'Cinco Schoonloopmat op Maat',
    slug: 'cinco-schoonloopmat',
    brand: 'Cinco Cleaning',
    category: 'inloopmatten',
    type: 'custom-size',
    price: null,
    customPricing: { unit: 'm2', pricePerUnit: 5995, minWidth: 50, maxWidth: 200, minLength: 50, maxLength: 300 },
    weight: 2000,
    sfProductCode: 'SHS-MAT-SCHOONLOOP',
    dropship: false,
    stock: false,
    image: '/products/cinco-schoonloopmat.png',
  },
  {
    id: 'cinco-droogloopmat',
    name: 'Cinco Droogloopmat op Maat',
    slug: 'cinco-droogloopmat',
    brand: 'Cinco Cleaning',
    category: 'inloopmatten',
    type: 'custom-size',
    price: null,
    customPricing: { unit: 'm2', pricePerUnit: 6995, minWidth: 50, maxWidth: 200, minLength: 50, maxLength: 300 },
    weight: 2500,
    sfProductCode: 'SHS-MAT-DROOGLOOP',
    dropship: false,
    stock: false,
    image: '/products/cinco-droogloopmat.png',
  },
  {
    id: 'cinco-buitenmat',
    name: 'Cinco Buitenmat op Maat',
    slug: 'cinco-buitenmat',
    brand: 'Cinco Cleaning',
    category: 'inloopmatten',
    type: 'custom-size',
    price: null,
    customPricing: { unit: 'm2', pricePerUnit: 4995, minWidth: 50, maxWidth: 200, minLength: 50, maxLength: 300 },
    weight: 3000,
    sfProductCode: 'SHS-MAT-BUITEN',
    dropship: false,
    stock: false,
    image: '/products/cinco-buitenmat.png',
  },

  // ---------------------------------------------------------------------------
  // Bescherming
  // ---------------------------------------------------------------------------
  {
    id: 'rena-vezelbeschermer-eco',
    name: 'Rena Vezelbeschermer Eco',
    slug: 'rena-vezelbeschermer-eco',
    brand: 'Cinco Cleaning',
    category: 'bescherming',
    type: 'simple',
    price: 2995,
    weight: 560,
    sfProductCode: 'SHS-BESCH-RENA-ECO',
    dropship: false,
    stock: true,
    image: '/products/rena-vezelbeschermer-eco.png',
  },
  {
    id: 'rena-onderhoudsset',
    name: 'Rena Onderhoudsset voor Tapijt en Meubels',
    slug: 'rena-onderhoudsset',
    brand: 'Cinco Cleaning',
    category: 'bescherming',
    type: 'simple',
    price: 3995,
    weight: 1000,
    sfProductCode: 'SHS-BESCH-RENA-SET',
    dropship: false,
    stock: true,
    image: '/products/rena-onderhoudsset.png',
  },

  // ---------------------------------------------------------------------------
  // SEBO Onderdelen (dropship)
  // ---------------------------------------------------------------------------
  {
    id: 'sebo-et-1-borstelmond',
    name: 'SEBO ET-1 Elektrische Borstelmond',
    slug: 'sebo-et-1-borstelmond',
    brand: 'SEBO',
    category: 'sebo-onderdelen',
    type: 'simple',
    price: 25900,
    weight: 3500,
    sfProductCode: 'SHS-SEBO-ET1',
    dropship: true,
    stock: true,
    image: '/products/sebo-et-1-borstelmond.png',
  },
  {
    id: 'sebo-combi-zuigmond',
    name: 'SEBO COMBI Zuigmond',
    slug: 'sebo-combi-zuigmond',
    brand: 'SEBO',
    category: 'sebo-onderdelen',
    type: 'simple',
    price: 4050,
    weight: 800,
    sfProductCode: 'SHS-SEBO-COMBI',
    dropship: true,
    stock: true,
    image: '/products/sebo-combi-zuigmond.png',
  },
  {
    id: 'sebo-parquet-zuigmond',
    name: 'SEBO PARQUET Zuigmond',
    slug: 'sebo-parquet-zuigmond',
    brand: 'SEBO',
    category: 'sebo-onderdelen',
    type: 'simple',
    price: 5850,
    weight: 750,
    sfProductCode: 'SHS-SEBO-PARQUET',
    dropship: true,
    stock: true,
    image: '/products/sebo-parquet-zuigmond.png',
  },
  {
    id: 'sebo-borstelwals-31cm',
    name: 'SEBO Borstelwals 31 cm',
    slug: 'sebo-borstelwals-31cm',
    brand: 'SEBO',
    category: 'sebo-onderdelen',
    type: 'simple',
    price: 2499,
    weight: 300,
    sfProductCode: 'SHS-SEBO-WALS-31',
    dropship: true,
    stock: true,
    image: '/products/sebo-borstelwals-31cm.png',
  },
  {
    id: 'sebo-borstelwals-37cm',
    name: 'SEBO Borstelwals 37 cm',
    slug: 'sebo-borstelwals-37cm',
    brand: 'SEBO',
    category: 'sebo-onderdelen',
    type: 'simple',
    price: 2999,
    weight: 400,
    sfProductCode: 'SHS-SEBO-WALS-37',
    dropship: true,
    stock: true,
    image: '/products/sebo-borstelwals-37cm.png',
  },
  {
    id: 'sebo-turboborstel-tt-c',
    name: 'SEBO Turboborstel TT-C',
    slug: 'sebo-turboborstel-tt-c',
    brand: 'SEBO',
    category: 'sebo-onderdelen',
    type: 'simple',
    price: 8150,
    weight: 900,
    sfProductCode: 'SHS-SEBO-TTC',
    dropship: true,
    stock: true,
    image: '/products/sebo-turboborstel-tt-c.png',
  },

  // ---------------------------------------------------------------------------
  // Apparaten Verhuur
  // ---------------------------------------------------------------------------
  {
    id: 'reinigingsmachine-huren',
    name: 'Reinigingsmachine Huren',
    slug: 'reinigingsmachine-huren',
    brand: 'SofaSaver',
    category: 'apparaten-verhuur',
    type: 'simple',
    price: 7500,
    weight: 0,
    sfProductCode: '',
    dropship: false,
    stock: true,
    image: '/products/sofasaver-machine.png',
  },
]

// =============================================================================
// Helpers
// =============================================================================

export function getProductById(id: string): CatalogProduct | undefined {
  return products.find((p) => p.id === id)
}

export function getProductsByCategory(categoryId: string): CatalogProduct[] {
  return products.filter((p) => p.category === categoryId)
}

export function formatPrice(cents: number): string {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100)
}
